import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import ReactHtmlParser from 'react-html-parser';

import { formatPrice, goToTop, getLoading, setCursorWaiting, getFinanceWeekly, getLeaseBiWeeklyFromOptions, getLang, getBaseUrl, get360Data, hideCmsHiddenBlock} from '../../../utils';

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import SummaryCalculator from '../../../Helpers/summarycalculator';
import GTMHelper from '../../../Helpers/gtmHelper';
import NavHelper from '../../../Helpers/navhelper';

import { Svg } from '../../1_Atoms/Svg/Svg';
import Button from '../../1_Atoms/Button/Button';
import CollapseLegal from '../../2_Molecules/Collapse/CollapseLegal';
import ColourCard from '../../2_Molecules/ColourCard/ColourCard';
import ThreeSixtyContainer from '../../3_Organisms/360Container/360Container';
import { Nav } from '../../3_Organisms/Nav/Nav';
import { Pricing } from '../../3_Organisms/Pricing/Pricing';
import { Modal } from '../../3_Organisms/Modal/Modal';
import { PreOrderModal } from '../../3_Organisms/Modal/PreOrderModal';
import { Alert } from '../../3_Organisms/Alert/Alert';

export const Protection = ({ ...props }) => {
    const baseURL = getBaseUrl();
    const lang = getLang();
    const [loading, setLoading] = useState(true);
    const summaryCalculator = window.summaryCalculator;
    const { year, carline, trim, model, packageCode } = useParams();
    const [nav, setNav] = useState(null);
    const navigate = useNavigate();

    const [preorderOpen, setPreorderModalOpen] = React.useState(false);
    
    let images = {};
    
    if (summaryCalculator.SelectedColourExteriorIndex !== 'null' && summaryCalculator.Colours !== null) {
        const { exteriors, interiors } = summaryCalculator.Colours.visual;
        const selectedExterior = Object.entries(exteriors)[summaryCalculator.SelectedColourExteriorIndex][1];
        const selectedInterior = summaryCalculator.SelectedColourInteriorIndex !== 'null' ? interiors[summaryCalculator.SelectedColourInteriorIndex] : null;
        images = get360Data(summaryCalculator.Colours.visual, selectedExterior, selectedInterior);
    }
    const generateStaticVehicleImg = () => {
        if (images) {
            const { imagePath,  imageName } = images;
            const { year, carline, trim } = summaryCalculator.selectedVehicle
            const src = imagePath && imageName ? `${imagePath}${imageName.replace('{index}', 18)}` : '';
            return (
                <img src={src} alt={year + '' + carline + ' ' + trim} />
            )
        }
        return ''
    }

    const collapseRefProtection = useRef();
    const collapseRefAppearance = useRef();
    const [protectionExpanded, setProtectionExpanded] = useState(false);
    const [appearanceExpanded, setAppearanceExpanded] = useState(false);

    const legalContent = JSON.parse(sessionStorage.getItem(Constants.LegalProtections));
    const [legalModalOpen, setLegalModalOpen] = useState(false);
    const { t, i18n } = useTranslation(['protection', 'general']);
    const [showFinancePrice, setShowFinancePrice] = useState(summaryCalculator.ShowFinancePrice);

    const financial = JSON.parse(sessionStorage.getItem(Constants.FinancialObj));
    const financeTermIndex = parseInt(sessionStorage.getItem(Constants.FinanceTermIndex));
    const leaseTermIndex = parseInt(sessionStorage.getItem(Constants.LeaseTermIndex));

    const [selectedAddedProtectionIndex, setSelectedAddedProtectionIndex] = useState(summaryCalculator.SelectedAddedProtectionIndex);
    //const [selectedAppearanceProtectionIndex, setSelectedAppearanceProtectionIndex] = React.useState(summaryCalculator.SelectedAppearanceProtectionIndex);

    const [addedProtectionSection, setAddedProtectionSection] = useState(null);

    //const [appearanceDropDown, setAppearanceDropDown] = React.useState(Object.keys(summaryCalculator.Packages.appearance_protection[0].plans)[summaryCalculator.SelectedAppearanceProtectionIndex]);
    const [appearanceDropDown, setAppearanceDropDown] = useState(Object.keys(summaryCalculator.Packages.appearance_protection[0].plans)[0]);
    const [appearanceSelection, setAppearanceSelection] = useState(summaryCalculator.SelectedAppearanceProtectionPlansPackage.key !== undefined ? summaryCalculator.SelectedAppearanceProtectionPlansPackage.key : null);

    const gtmHelper = new GTMHelper();
    const navHelper = new NavHelper();

    hideCmsHiddenBlock();
    
    useEffect(() =>{
        const collapseProt = collapseRefProtection.current;
        const collapseApp = collapseRefAppearance.current;
        if(typeof window.mzAnimator === 'object'&& !protectionExpanded){
            window.mzAnimator.animateHeight(collapseApp, 'CollapseListApp', 'init')
            window.mzAnimator.animateHeight(collapseProt, 'CollapseListProt', 'init')
            console.log(collapseRefProtection)
        }
   },[addedProtectionSection]);
    
    useEffect(() =>{   
        const collapse = collapseRefProtection.current;
        if(protectionExpanded){
            window.mzAnimator.animateHeight(collapse, 'CollapseListProt', true)
        }else{
            window.mzAnimator.animateHeight(collapse, 'CollapseListProt', false)
        }
   },[protectionExpanded]);
   useEffect(() =>{   
        const collapse = collapseRefAppearance.current;

        if(appearanceExpanded){
            window.mzAnimator.animateHeight(collapse, 'CollapseListApp', true)
        }else{
            window.mzAnimator.animateHeight(collapse, 'CollapseListApp', false)
        }
    },[appearanceExpanded]);


    function hideShownCmsBlock() {
        let toHideBlocks = document.querySelectorAll('.mz-footer.visually-shown');
        if (toHideBlocks) {
            toHideBlocks.forEach(function (e) {
                e.classList.remove('visually-shown');
                e.classList.add('visually-hidden');
            });
        }
    }

    hideShownCmsBlock();

    summaryCalculator.CurrentStep = 7;

    useEffect(() => {
        async function executeTasks() {
            if (!summaryCalculator.isDataLoaded()) {
                await summaryCalculator.loadTrims(year, carline);

                const trimIndex = summaryCalculator.AvailableTrim.trims.findIndex(obj => obj.trim_type.name === trim);
                await summaryCalculator.setSelectedTrimIndex(trimIndex);

                setLoading(false);

                setNav(null);
            } else {
                setLoading(false);

            }

            if (!loading) {
                if (nav === null) {
                    const toRender = navHelper.getNavContent(t);
                    setNav(toRender);                    
                }
            }
        }

        executeTasks();
    }, [loading, nav, selectedAddedProtectionIndex, ]);

    useEffect(() => {
        if(addedProtectionSection === null) {
            setAddedProtectionSection(prepareAddedProtectionSection());
        }
    }, [addedProtectionSection]);

    function prepareAddedProtectionSection() {
        let section;

        if (summaryCalculator.SelectedAddedProtectionIndex == null) {
            /* DISPLAY THE TABLE IF WE HAVE NONE SELECTED*/
            section = getAddedProtectionPackage();
        } else {
            section = getCurrentAddedProtectionPackage();
        }

        return section;
    }

    function nextStep() {
        goToTop();
        navigate(`/${year}/${carline}/${trim}/${model}/${packageCode}/payments${decodeURI(window.location.search)}`)
        gtmHelper.setGTM({ 'action': 'Next Step' }, true, false);
    }

    async function handleSelectedAddedProtectionPackage(index) {
        setCursorWaiting(true);

        await summaryCalculator.setSelectedAddedProtectionIndex(index);

        gtmHelper.setGTM({ 'action': 'Added Protection Package Add', 'package': summaryCalculator.SelectedAddedProtectionPackage.option_code }, false, false); // TODO : CHECK WITH BARLOW IF IT'S A CODE OR INDEX

        setSelectedAddedProtectionIndex(index);

        setNav(null);

        setAddedProtectionSection(prepareAddedProtectionSection());
        
        setCursorWaiting(false);
    }

    async function handleRemoveAddedProtectionPackage() {
        setCursorWaiting(true);

        gtmHelper.setGTM({ 'action': 'Added Protection Package Remove', 'package': summaryCalculator.SelectedAddedProtectionPackage.option_code }, true, false); // TODO : CHECK WITH BARLOW IF IT'S A CODE OR INDEX

        await summaryCalculator.setSelectedAddedProtectionIndex(null);

        setSelectedAddedProtectionIndex(null);

        setNav(null);

        setAddedProtectionSection(prepareAddedProtectionSection());

        setCursorWaiting(false);
    }

    async function handleAppearanceProtectionTerms(index) {
        summaryCalculator.setSelectedAppearanceProtectionIndex(index);
    }

    async function handleAppearanceProtectionPlansPackage(index, key) {
        setCursorWaiting(true);

        setAppearanceSelection(key);

        await summaryCalculator.setSelectedAppearanceProtectionPlansIndex(index);

        gtmHelper.setGTM({ 'action': 'Appearance Protection Plans Package Add', 'package': summaryCalculator.SelectedAppearanceProtectionPlansPackage.name }, false, false); // TODO : CHECK WITH BARLOW IF IT'S A CODE OR INDEX

        setNav(null);

        setCursorWaiting(false);
    }

    async function handleRemoveAppearanceProtectionPlansPackage() {
        setCursorWaiting(true);

        setAppearanceSelection(null);

        gtmHelper.setGTM({ 'action': 'Appearance Protection Plans Package Remove', 'package': summaryCalculator.SelectedAppearanceProtectionPlansPackage.name }, true, false); // TODO : CHECK WITH BARLOW IF IT'S A CODE OR INDEX

        await summaryCalculator.setSelectedAppearanceProtectionPlansIndex(null);

        setNav(null);

        setCursorWaiting(false);
    }

    function handleShowFinanceClick(value) {
        setShowFinancePrice(value);
    }

    function getAddedProtectionPackage() {
        const addedProtectionPackageList = Object.entries(summaryCalculator.Packages.added_protection[0].plans).map(([key, plan], planIndex) => (
            <div className="mz-protection-packages__item" key={key}>
               <div><strong>{plan.name}</strong></div>
               <span>+ {formatPrice(plan.financial.msrp)} <span className="label">{
                        `(${showFinancePrice?
                            `${getFinanceWeekly(plan.financial.msrp, financial.calculatedFinance.financeValues[financeTermIndex].aprRate, financial.calculatedFinance.financeValues[financeTermIndex].term)}${t("general:week")}`:
                            `${getLeaseBiWeeklyFromOptions(plan.financial.msrp, financial.calculatedLease.leaseValues[leaseTermIndex].leaseRate, financial.calculatedLease.leaseValues[leaseTermIndex].term)}${t("general:bi_week")}`})`}</span></span>
                <button className="mz-btn mz-btn--primary mz-btn--red" onClick={()=>handleSelectedAddedProtectionPackage(planIndex)}><span>{t('general','add')}</span></button>
            </div>
        ));

        return (<div className="mz-protection-packages">
            {addedProtectionPackageList}
        </div>
        )
    }

    function getCurrentAddedProtectionPackage() {
        const plan = summaryCalculator.SelectedAddedProtectionPackage.financial.msrp;
        return (<div>
            <div><strong>{summaryCalculator.SelectedAddedProtectionPackage.name}</strong></div>
            <p><span>+ {formatPrice(plan)} <span className="label">{
                        `(${showFinancePrice?
                            `${getFinanceWeekly(plan, financial.calculatedFinance.financeValues[financeTermIndex].aprRate, financial.calculatedFinance.financeValues[financeTermIndex].term)}${t("general:week")}`:
                            `${getLeaseBiWeeklyFromOptions(plan, financial.calculatedLease.leaseValues[leaseTermIndex].leaseRate, financial.calculatedLease.leaseValues[leaseTermIndex].term)}${t("general:bi_week")}`})`}</span></span>
            </p>
            <button className="mz-btn mz-btn--primary" onClick={()=>{handleRemoveAddedProtectionPackage()}}><span>{t('general','remove')}</span></button> 
        </div>)
    }

    function getAppearanceProtectionSection() {
        if (appearanceSelection === null) {
            return (
                <>
                    {getAppearanceProtectionTermsDropDown()}
                    {getAppearanceProtectionList()}
                </>
            )
        } else {
            const appearanceProtectionPlan = summaryCalculator.SelectedAppearanceProtectionPlan;
            const plan = appearanceProtectionPlan.packages[appearanceSelection].financial.msrp;
            return (
                <div>
                    <div>
                        <p><strong>{summaryCalculator.SelectedAppearanceProtectionPlansPackage.name} ({appearanceProtectionPlan.name})</strong></p>
                        <p><span>+ {formatPrice(plan)} <span className="label">{
                        `(${showFinancePrice?
                            `${getFinanceWeekly(plan, financial.calculatedFinance.financeValues[financeTermIndex].aprRate, financial.calculatedFinance.financeValues[financeTermIndex].term)}${t("general:week")}`:
                            `${getLeaseBiWeeklyFromOptions(plan, financial.calculatedLease.leaseValues[leaseTermIndex].leaseRate, financial.calculatedLease.leaseValues[leaseTermIndex].term)}${t("general:bi_week")}`})`}</span></span></p>
                    </div>
                    <p><button className="mz-btn mz-btn--primary" onClick={()=>{handleRemoveAppearanceProtectionPlansPackage()}}><span>{t('general','remove')}</span></button> </p>
                </div>
            )
        }
    }

    // TODO : LOOK WHAT WE DO WITH THOSE ICONS
    function getAddedProtectionIcons() {
        if (summaryCalculator.Packages.added_protection.length === 0)
            return;

        const src =`${baseURL}/globalassets/mazda-canada/react/images/mazdaaddedprotection_${lang}.png`;

        return (<img src={src} />)
    }

    // TODO : LOOK WHAT WE DO WITH THOSE ICONS
    function getAppearanceProtectionIcons() {
        if (summaryCalculator.Packages.appearance_protection.length === 0)
            return;

        const iconList = summaryCalculator.Packages.appearance_protection[0].icons.map((icon, index) => (
            <div key={index}>
                <i className={`mz-svg mz-svg-appearance_${icon.name}`}></i>
            </div>
        ));

        return (<div>
            {iconList}
        </div>
        )
    }

    function setExpand(title, innerContent, target) {
        // HACK FOR THE COLLAPSIBLE ON CTRL-R
        if (!innerContent) 
            return (
                <>
                </>
            )
        
        let active='';
        let visible='';
        let ref=null;
        if(target === 'protection' && protectionExpanded){
            active='active';
            ref=collapseRefProtection;
        }else if(target === 'protection'){
            ref=collapseRefProtection;
        }else if(target === 'appearance' && appearanceExpanded){
            active='active';
            ref=collapseRefAppearance;
        }else if(target === 'appearance'){
            ref=collapseRefAppearance;
        }
        console.log(target, active, ref)
        return (<div className="mz-collapse mz-container-flex">
            <button className={`mz-collapse__button ${active}`} onClick={(e)=>{expandToggle(target)}}>
                <h5>{title}</h5>
                <i className="mz-svg mz-svg-chevroncarousel mz-svg--grey"></i>
            </button>
            <div className={`mz-collapse__box`} ref={ref}>
                <div className="mz-collapse__box-inner">
                    {innerContent}
                </div>
            </div>
        </div>)
    }

    function expandToggle(target){
        if(target === 'protection'){
            setProtectionExpanded(!protectionExpanded);
        }else{
            setAppearanceExpanded(!appearanceExpanded);
        }
    }

    function getAppearanceProtectionTermsDropDown() {
        const terms = Object.entries(summaryCalculator.Packages.appearance_protection[0].plans).map(([key, appearanceProtectionPlans], index) =>
            <option value={key} index={index} key={key}>{appearanceProtectionPlans.name}</option>
        );
        return (
            <div className="mz-protection-page__appearanceSelect">

                <span className="label text--grey">{summaryCalculator.Packages.appearance_protection[0].term_dropdown_label}</span>
                <div className="mz-form-item mz-form-item--select ">
                    <select className="mz-form-item__select" defaultValue={appearanceDropDown} onChange={(e)=>{
                        setAppearanceDropDown(e.target.value);
                        handleAppearanceProtectionTerms(e.currentTarget.querySelector(`option[value="${e.target.value}"]`).getAttribute('index'))
                    }}>
                        {terms}
                    </select>
                
                    <div className="mz-form-item__arrow-down">
                        <div className="mz-svg-wrapper " style={{ fontSize: '0.75rem' }}>
                            <i className="mz-svg mz-svg--grey undefined mz-svg-chevron_small_down"></i>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

    function getAppearanceProtectionList() {
        const plans = Object.entries(summaryCalculator.Packages.appearance_protection[0].plans[appearanceDropDown].packages).map(([key, appearanceProtectionPlansPackage], index) => (
            <div className="mz-protection-page__appearance" key={key}>
                <div className="mz-protection-page__appearance-name">{appearanceProtectionPlansPackage.popular===1 ? <><span className="label">popular</span><br/></> : ""}{appearanceProtectionPlansPackage.name}</div>
                <div className="mz-protection-page__appearance-price">
                    <div className="text--grey">+ {formatPrice(appearanceProtectionPlansPackage.financial.msrp)} <span className="label">{
                        `(${showFinancePrice?
                            `${getFinanceWeekly(appearanceProtectionPlansPackage.financial.msrp, financial.calculatedFinance.financeValues[financeTermIndex].aprRate, financial.calculatedFinance.financeValues[financeTermIndex].term)}${t("general:week")}`:
                            `${getLeaseBiWeeklyFromOptions(appearanceProtectionPlansPackage.financial.msrp, financial.calculatedLease.leaseValues[leaseTermIndex].leaseRate, financial.calculatedLease.leaseValues[leaseTermIndex].term)}${t("general:bi_week")}`})`}</span></div>
                    <button className="mz-btn mz-btn--primary mz-btn--red" onClick={()=>handleAppearanceProtectionPlansPackage(index, key)}><span>{t('general','add')}</span></button> 
                </div>
            </div>
        ));

        return (
            <>
                {plans}
            </>
        )
    }

    function scrollToID(id){
        const target = document.getElementById(id);
        window.gsap.to(window, {duration: 1, scrollTo: {y: target, offsetY: window.mzFunc.offsetMenu + 60, autoKill: true}});
    }

    return (
        <>
            {
                !summaryCalculator.isDataLoaded() ? getLoading(loading, t) : null
            }
            <div className="mz-protection-page mz-top-nav-spacing grid-no-gutter-sm">
                <Nav nav={nav} />
                <Alert />

                <h5 className="mz-protection-page__title">{t("title")}</h5>
                <div className="mz-protection-page__subtitle">
                    <a className="mz-link" onClick={()=>{scrollToID('map')}}>{ReactHtmlParser(summaryCalculator.Packages.added_protection[0].title.toLowerCase())}</a> {t("and")} <a  className="mz-link nowrap" onClick={()=>{scrollToID('ap')}}>{ReactHtmlParser(summaryCalculator.Packages.appearance_protection[0].title.toLowerCase())}</a>
                </div>
                <div className="mz-full-width mz-protection-page__content">
                    {summaryCalculator.Packages.added_protection &&
                        <section id="map">
                            <h5>{ReactHtmlParser(summaryCalculator.Packages.added_protection[0].title)}</h5>

                            <div className="mz-protection-page__content-container">
                                <div className="mz-protection-page__content-container__content-left">
                                    {generateStaticVehicleImg()}
                                    {getAddedProtectionIcons()}
                                </div>
                                <div className="mz-protection-page__content-container__content-right">
                                    {ReactHtmlParser(summaryCalculator.Packages.added_protection[0].description)}
                                </div>
                            </div>
                            { summaryCalculator.SelectedAddedProtectionIndex == null ? 
                                setExpand(summaryCalculator.Packages.added_protection[0].accordion_title, addedProtectionSection, 'protection') :
                                <div className="mz-container-flex">
                                    <div className="mz-protection-page__selectedBox">
                                        <div className="mz-protection-page__selected-indicator"><i className="mz-svg mz-svg--white mz-svg-checkmark"></i></div>
                                        <h5>{ReactHtmlParser(summaryCalculator.Packages.added_protection[0].selected_plan_text)}</h5> 
                                        {addedProtectionSection}
                                    </div>
                                </div>
                            }
                        </section>}

                    <section id="ap">
                        <h5>{ReactHtmlParser(summaryCalculator.Packages.appearance_protection[0].title)}</h5>

                        <div className="mz-protection-page__content-container">
                            <div className="mz-protection-page__content-container__content-left">
                                {generateStaticVehicleImg()}
                                {getAppearanceProtectionIcons()}
                            </div>
                            <div className="mz-protection-page__content-container__content-right protection-features-introduction">
                                {ReactHtmlParser(summaryCalculator.Packages.appearance_protection[0].description)}
                            </div>
                        </div>
                            {appearanceSelection === null ?
                                setExpand(summaryCalculator.Packages.appearance_protection[0].accordion_title , getAppearanceProtectionSection(), 'appearance'):
                                <div className="mz-container-flex">
                                    <div className="mz-protection-page__selectedBox">
                                        <div className="mz-protection-page__selected-indicator"><i className="mz-svg mz-svg--white mz-svg-checkmark"></i></div>
                                            <h5>{ReactHtmlParser(summaryCalculator.Packages.appearance_protection[0].selected_plan_text)}</h5> 
                                            {getAppearanceProtectionSection()}
                                    </div>
                                </div>
                            }

                    </section>
                </div>
                
                <div className="mz-legal mz-mobile">
                    <Button
                        className="mz-btn mz-btn--legal text--grey"
                        label={t("general:legal")}
                        backgroundColor="grey"
                        colour="grey"
                        icon={true}
                        iconAfter={true}
                        svg_className=""
                        svg_list="plus"
                        size={0.6}
                        onClick={() => {
                            document.querySelector('body').classList.add('disabled');
                            setLegalModalOpen(true)
                        }}
                    />
                </div>

                <Pricing builtLabel={t("general:price_as_built")} builtPrice="$" loanLabel={t("general:loan_label")} loanPrice="$" saveLabel={t("general:save_build")}
                    leaseLabel={t("general:show_lease_price")} financeLabel={t("general:show_finance_price")} buttonLabel={t("general:next_payments")} summaryCalculator={summaryCalculator}
                    HandleNextClick={nextStep} setLegalModalOpen={setLegalModalOpen} HandleShowFinanceClick={handleShowFinanceClick} setPreorderModalOpen={setPreorderModalOpen} />
                <Modal modalContent={legalContent} isOpen={legalModalOpen} handleClose={setLegalModalOpen} modalId='legalModal' />
                <PreOrderModal isOpen={preorderOpen} handleClose={setPreorderModalOpen}></PreOrderModal> 
            </div>
        </>
        
    )
}

export default Protection